import { Box } from "@mui/system";
import type { FC } from "react";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import type { CreateBatchUsersForNurseResponse } from "../../../utils/models";
import SystemDialog from "../../UIToolkit/Popups/Dialog";

type Props = {
	data: CreateBatchUsersForNurseResponse;
	onClose?: () => void;
};

export const CreateMissingUsersSummaryPopup: FC<Props> = ({ data, onClose }) => {
	const { getNurseNameFromId } = useHospitalData();
	return (
		<SystemDialog
			open={true}
			onClose={() => onClose?.()}
			title={"Creation Summary"}
			onConfirm={(_) => onClose?.()}
			hideCancel={true}
			body={
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						overflow: "auto",
						maxHeight: "80vh",
						gap: 1,
						p: 1,
					}}
				>
					{data.createdUserIds.length > 0 ? `Successfully created ${data.createdUserIds.length} users.` : "No new users were created."}
					<br />
					{data.errors.length > 0 ? `Failed to create ${data.errors.length} users.` : null}

					{data.errors.length > 0 && (
						<>
							<br />
							<br />
							Nurses with errors:
							{data.errors.map((error) => (
								<ul key={error.nurseId}>
									- ID:{error.nurseId} Name:{getNurseNameFromId(error.nurseId)}
								</ul>
							))}
						</>
					)}
				</Box>
			}
		/>
	);
};
